import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { ConfigurationState } from 'src/app/proxy/service-configurations';

@Component({
  selector: 'app-service-configuration-state-dropdown',
  templateUrl: './service-configuration-state-dropdown.component.html',
  standalone: false,
})
export class ServiceConfigurationStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() serviceConfigurationState: ConfigurationState;

  @Output() changeServiceConfigurationState = new EventEmitter<ConfigurationState>();

  serviceConfigurationStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.serviceConfigurationState)) {
      this.serviceConfigurationState = ConfigurationState.Active;
    }

    this.loadServiceConfigurationState();
    this.onSelected();
  }

  loadServiceConfigurationState(): void {
    this.serviceConfigurationStates = this.getEnumOptions(ConfigurationState, false);
  }
  
  setSelectedState(state: ConfigurationState | undefined): void {
      this.serviceConfigurationState = state;
    this.onSelected(); 
  }

  onSelected(): void {
    this.changeServiceConfigurationState.emit(this.serviceConfigurationState);
  }
}